import {
  type AvatarProps,
  createPolymorphicComponent,
  Avatar as MantineAvatar,
  type MantineStyleProps,
} from "@mantine/core";

type Props = AvatarProps & MantineStyleProps;

export function _Avatar(props: Props) {
  const { children, ...avatarProps } = props;
  const defaultOption: Omit<AvatarProps, "children"> = {
    radius: "lg",
  };
  const option = Object.assign({}, defaultOption, avatarProps);
  return <MantineAvatar {...option}>{children}</MantineAvatar>;
}

export const Avatar = createPolymorphicComponent<"div", AvatarProps>(_Avatar);
